import { SimpleInput } from './SimpleInput';

export default SimpleInput;
